import { FC } from "react";

import { 
  DetailCard,
} from "../../../../../components/layout"

import { DLMSiteApplication, DLMSiteApplicationDetail } from "../../_models";

import { sortBy, filter } from "lodash";

type Props = {
  selectedSite: DLMSiteApplication | null,
  isDoor: boolean
}

const SiteItemDetails: FC<Props> = ({ selectedSite, isDoor}) => {
  
  if (! (selectedSite && selectedSite?.siteApplicationDetails && selectedSite.siteApplicationDetails.length > 0)) {
      return null;
  }

  return(    
  <DetailCard cardTitle="Site Item Details">
    <div className='table-responsive min-h-80px mh-150px'>
      <table
        className='table align-middle table-row-bordered table-row-gray-300 fs-7 gy-2 dataTable no-footer'
      >
        <thead>
          <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
            <th className="p-2">No</th>
            <th className="p-2">Size W x H (mm) / Model</th>
            <th className="p-2">Quantity</th>
            { isDoor && 
            <>
            <th className="p-2">Leaf Type</th>
            <th className="p-2">Vision Panel</th>
            </>
            }
            <th className="p-2">Remarks</th>            
          </tr>
        </thead>
        <tbody className='text-gray-800 align-middle fs-7'>
        { sortBy(filter(selectedSite.siteApplicationDetails, (obj) => (! obj?.deleted)), [(o) => parseInt(`${o.itemNo}`)],['asc']).map((item: DLMSiteApplicationDetail, idx: number) => (
          <tr key={`siteItemDetail-${selectedSite.id}_${idx}`} >
            <td className="p-2 align-top">
              <div>
                {item?.itemNo ? item?.itemNo : idx + 1 }
              </div>
            </td>
            <td className="p-2 align-top">
              <div>
                {item.size}
              </div>
            </td>
            <td className="p-2 align-top">
              <div>
                {item.quantity}
              </div>
            </td>
            { isDoor && 
            <>
            <td className="p-2 align-top">
              <div>
                {item.doorType}
              </div>
            </td>
            <td className="p-2 align-top">
              <div>
                {item.visionPanel ? 'YES' : 'NO'}
              </div>
            </td>
            </>
            }
            <td className="p-2 align-top">
              <div>
                {item.remarks}
              </div>
            </td>
          </tr>
        ))
        }
        </tbody>
      </table>
    </div>
  </DetailCard>      
  )
}

export { SiteItemDetails } 